// ✅ WorkerLayout.js — FIXED MOBILE SPACING + CLEAN UI
import React from "react";
import { useLocation } from "react-router-dom";
import WorkerNavbar from "./WorkerNavbar";
import MobileNavbar from "./MobileNavbar";
import RideBottomNav from "./RideBottomNav";
import { Toaster } from "react-hot-toast";

const WorkerLayout = ({ children }) => {
  const location = useLocation();

  const hideNavRoutes = [
    "/worker-login",
    "/worker-signup",
    "/legal-name",
    "/verify-phone",
    "/otp-verification",
    "/set-address",
    "/upload-documents",
    "/select-services",
    "/review-profile",
    "/upload-profile-photo",
    "/reupload-id",
  ];

  const isRidePage =
    location.pathname.startsWith("/ride") ||
    location.pathname.startsWith("/worker/ride");

  const hideNav = hideNavRoutes.some((r) =>
    location.pathname.startsWith(r)
  );

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Toaster position="top-center" />

      {/* DESKTOP NAV */}
      {!hideNav && (
        <div className="hidden md:block fixed top-0 left-0 right-0 z-50">
          <WorkerNavbar />
        </div>
      )}

      {/* MOBILE NAV */}
      {!hideNav && (
        <>
          {!isRidePage && (
            <div className="block md:hidden fixed bottom-0 left-0 right-0 z-50">
              <MobileNavbar />
            </div>
          )}

          {isRidePage && (
            <div className="block md:hidden fixed bottom-0 left-0 right-0 z-50">
              <RideBottomNav />
            </div>
          )}
        </>
      )}

      {/* MAIN CONTENT */}
      <main
        className={`
          flex-1 w-full min-h-screen
          ${hideNav ? "pt-0 pb-0" : ""}
          md:pt-20 
          md:pb-0
          bg-white
        `}
      >
        {children}
      </main>
    </div>
  );
};

export default WorkerLayout;
